/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cd_minutes = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minutes`)
};

const es_cd_minutes = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minutos`)
};

const de_cd_minutes = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuten`)
};

const nl_cd_minutes = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuten`)
};

const fr_cd_minutes = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minutes`)
};

const it_cd_minutes = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuti`)
};

const pt_br2_cd_minutes = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minutos`)
};

const pt_cd_minutes = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minutos`)
};

const ja_cd_minutes = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分`)
};

const zh_cd_minutes = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分钟`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cd_minutes = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cd_minutes(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cd_minutes", locale)
	if (locale === "en") return en_cd_minutes(inputs)
	if (locale === "es") return es_cd_minutes(inputs)
	if (locale === "de") return de_cd_minutes(inputs)
	if (locale === "nl") return nl_cd_minutes(inputs)
	if (locale === "fr") return fr_cd_minutes(inputs)
	if (locale === "it") return it_cd_minutes(inputs)
	if (locale === "pt-BR") return pt_br2_cd_minutes(inputs)
	if (locale === "pt") return pt_cd_minutes(inputs)
	if (locale === "ja") return ja_cd_minutes(inputs)
	return zh_cd_minutes(inputs)
};